export default "__VITE_ASSET__Bev1Jseq__"